(() => {
  const limits = { product: 160, sku: 80, source: 200, category: 160 };
  const labels = { product: 'Product', sku: 'SKU', source: 'Source', category: 'Category' };
  const params = new URLSearchParams(window.location.search);
  const context = Object.fromEntries(
    Object.entries(limits).map(([key, limit]) => [
      key,
      (params.get(key) || '').replace(/[\u0000-\u001f\u007f\u2028\u2029]+/g, ' ').trim().slice(0, limit)
    ])
  );

  function init(root = document) {
    root.querySelectorAll('.absen-contact-map-form__form:not([data-inquiry-ready])').forEach((form) => {
      form.dataset.inquiryReady = 'true';

      for (const [key, value] of Object.entries(context)) {
        if (!value) continue;
        const field = form.querySelector(`[data-inquiry-field="${key}"]`);
        field.value = value;
        field.disabled = false;
      }

      const summary = form.querySelector('[data-inquiry-summary]');
      const visibleContext = [context.product, context.sku, context.category].filter(Boolean);
      if (visibleContext.length) {
        summary.textContent = visibleContext.join(' · ');
        summary.hidden = false;
      }

      const lines = Object.entries(context)
        .filter(([, value]) => value)
        .map(([key, value]) => `${labels[key]}: ${value}`);
      if (!lines.length) return;

      form.addEventListener('submit', () => {
        const message = form.querySelector('textarea[name="contact[body]"]');
        const appendix = lines.join('\n');
        if (!message.value.includes(appendix)) {
          message.value = `${message.value}\n\n${appendix}`;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
